// Lightweight GA4 helper that expects gtag.js to be loaded via public/index.html
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export const pageview = (url: string) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', { page_path: url });
  }
};

export const event = (action: string, params: Record<string, any> = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', action, params);
  }
};

export const isGtagLoaded = () =>
  typeof window !== 'undefined' && typeof window.gtag === 'function';
